module.exports = __webpack_public_path__ + "static/media/GoetheFFClan-Book.a57a6526.ttf";